import {OpenCabQueue, OpenCabQueueActionTypes} from "./types";
import {ActionsUnion, createAction} from "../definitions";

// eslint-disable-next-line @typescript-eslint/naming-convention
export const OpenCabQueueActions = {
    enqueueOpenCabQueue: (payload: OpenCabQueue) => createAction(OpenCabQueueActionTypes.ENQUEUE_OPENCABQUEUE, payload),
    dequeueOpenCabQueue: () => createAction(OpenCabQueueActionTypes.DEQUEUE_OPENCABQUEUE),
    clearOpenCabQueue: () => createAction(OpenCabQueueActionTypes.CLEAR_OPENCABQUEUE)
};

// eslint-disable-next-line @typescript-eslint/no-redeclare
export type OpenCabQueueActions = ActionsUnion<typeof OpenCabQueueActions>;